import React from "react";
import { IconControl } from "spark-core-dx/components";
import {
  getSectionStepLabel,
  getSectionStepNavigationItems,
  getStepLetter,
} from "./resourceConfigWizardUtils";

const WizardSectionNav = ({
  sectionSteps,
  activeSectionStepKey,
  wizard,
  stepKey,
  onSelectSectionStep,
  onRequestEditSectionStep
}) => {
  const navigationItems = getSectionStepNavigationItems(sectionSteps, wizard, stepKey, activeSectionStepKey);

  return (
    <nav className="resource-wizard__section-nav" aria-label="Section steps">
      {navigationItems.map(({
        sectionStep,
        sectionStepKey,
        completed,
        locked,
        active,
        current,
        canEditPrevious,
        showCompletedBadge,
        disabled
      }, index) => {
        const canEdit = canEditPrevious && typeof onRequestEditSectionStep === "function";
        return (
          <div key={sectionStepKey} className={`resource-wizard__section-step-shell${(showCompletedBadge || (completed && canEditPrevious && !canEdit)) ? " completed" : ""}${canEdit ? " can-edit" : ""}`}>
            {(showCompletedBadge || (completed && canEditPrevious && !canEdit)) ? (
              <span className="resource-wizard__section-step-complete" title={`${getSectionStepLabel(sectionStep)} complete`} aria-label={`${getSectionStepLabel(sectionStep)} complete`}>
                <span className="material-symbols-rounded" aria-hidden="true">check</span>
              </span>
            ) : null}
            {canEdit ? (
              <button
                type="button"
                className="resource-wizard__section-step-edit"
                title={`Edit ${getSectionStepLabel(sectionStep)}`}
                aria-label={`Edit ${getSectionStepLabel(sectionStep)}`}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onRequestEditSectionStep(sectionStepKey);
                }}
              >
                <IconControl iconKey="edit" width="0.85rem" height="0.85rem" />
              </button>
            ) : null}
            <button
              type="button"
              data-section-step-key={sectionStepKey}
              className={`resource-wizard__section-step${active ? " active" : ""}${current ? " current" : ""}${completed ? " completed" : ""}${(locked || disabled) ? " locked" : ""}`}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (disabled) return;
                onSelectSectionStep(stepKey, sectionStepKey);
              }}
              disabled={disabled}
            >
              <span className="resource-wizard__section-step-marker">{getStepLetter(index)}</span>
              <strong>{getSectionStepLabel(sectionStep)}</strong>
            </button>
          </div>
        );
      })}
    </nav>
  );
};

export default WizardSectionNav;
